import { defaultDictionaryValueMissing } from '../repository';

export type DocumentKey = 'Document' | 'DocumentDate' | 'MoreInfo';

export const getDefaultDocumentValue = (key: DocumentKey): string => {
	switch (key) {
		case 'Document':
		case 'DocumentDate':
		case 'MoreInfo':
		default:
			return `${defaultDictionaryValueMissing}:${key}`;
	}
};
